<div class="lucky-page">

    <div class="lucky-card">

        <!-- Etiqueta de comunidad (solo si viene comunidad) -->
        <div class="community-tag" *ngIf="community"
            [style.background-color]="community?.colorTheme || '#753CFD'">
            <img class="community-tag-avatar" [src]="community?.imageUrl || 'assets/images/noimage.png'"
                onerror="this.src='assets/images/noimage.png'" alt="">
            <div class="community-tag-name">{{ community?.name }}</div>
        </div>

        <!-- Header con color de la raspadita, confeti y titulo -->
        <div class="lucky-header">
            <div class="lucky-header-dark" [style.background-color]="scratch?.colorTheme || '#1A1B27'">
                <img src="assets/images/Confetti.gif" class="lucky-particles" alt="">
            </div>

            <div class="lucky-title">{{ scratch?.name || title }}</div>

            <div class="lucky-banner" *ngIf="scratch?.logoUrl">
                <img [src]="scratch?.logoUrl" alt="">
                <div class="lucky-banner-shine"></div>
            </div>
        </div>

        <!-- Cuerpo blanco (scrollable) -->
        <div class="lucky-body">
            <ng-content></ng-content>
        </div>
    </div>

    <!-- Panel PREMIOS lateral -->
    <app-lucky-prizes-panel *ngIf="showPrizesPanel && scratch?.showPrizes"
        [coupons]="scratch?.coupons || []"
        [showProbability]="scratch?.showProbability"
        [probability]="scratch?.probability">
    </app-lucky-prizes-panel>
</div>
